module.exports = __webpack_public_path__ + "img/cg-blue.86e3074f.svg";